__turbopack_context__.v({
  "approachSection": "vertaaux-module__2Kcjfa__approachSection",
  "brandCaption": "vertaaux-module__2Kcjfa__brandCaption",
  "brandFigure": "vertaaux-module__2Kcjfa__brandFigure",
  "brandImage": "vertaaux-module__2Kcjfa__brandImage",
  "brandImageGrid": "vertaaux-module__2Kcjfa__brandImageGrid",
  "fontWaterfall": "vertaaux-module__2Kcjfa__fontWaterfall",
  "hero": "vertaaux-module__2Kcjfa__hero",
  "heroAccent": "vertaaux-module__2Kcjfa__heroAccent",
  "imageGrid": "vertaaux-module__2Kcjfa__imageGrid",
  "logoCaption": "vertaaux-module__2Kcjfa__logoCaption",
  "logoCard": "vertaaux-module__2Kcjfa__logoCard",
  "logoCardDark": "vertaaux-module__2Kcjfa__logoCardDark",
  "logoCardGradient": "vertaaux-module__2Kcjfa__logoCardGradient",
  "logoCardLight": "vertaaux-module__2Kcjfa__logoCardLight",
  "logoCardMark": "vertaaux-module__2Kcjfa__logoCardMark",
  "logoCardWordmark": "vertaaux-module__2Kcjfa__logoCardWordmark",
  "logoGrid": "vertaaux-module__2Kcjfa__logoGrid",
  "logoGridSection": "vertaaux-module__2Kcjfa__logoGridSection",
  "logoGridWordmarks": "vertaaux-module__2Kcjfa__logoGridWordmarks",
  "logoImageMark": "vertaaux-module__2Kcjfa__logoImageMark",
  "logoImageRound": "vertaaux-module__2Kcjfa__logoImageRound",
  "logoImageWordmark": "vertaaux-module__2Kcjfa__logoImageWordmark",
  "metaBlock": "vertaaux-module__2Kcjfa__metaBlock",
  "metaGrid": "vertaaux-module__2Kcjfa__metaGrid",
  "metaLabel": "vertaaux-module__2Kcjfa__metaLabel",
  "metaLeft": "vertaaux-module__2Kcjfa__metaLeft",
  "metaOverview": "vertaaux-module__2Kcjfa__metaOverview",
  "metaRight": "vertaaux-module__2Kcjfa__metaRight",
  "metaSection": "vertaaux-module__2Kcjfa__metaSection",
  "metaText": "vertaaux-module__2Kcjfa__metaText",
  "metaTools": "vertaaux-module__2Kcjfa__metaTools",
  "metricDetail": "vertaaux-module__2Kcjfa__metricDetail",
  "metricItem": "vertaaux-module__2Kcjfa__metricItem",
  "metricLabel": "vertaaux-module__2Kcjfa__metricLabel",
  "metricValue": "vertaaux-module__2Kcjfa__metricValue",
  "metricsContent": "vertaaux-module__2Kcjfa__metricsContent",
  "metricsGrid": "vertaaux-module__2Kcjfa__metricsGrid",
  "metricsSection": "vertaaux-module__2Kcjfa__metricsSection",
  "outcomesSection": "vertaaux-module__2Kcjfa__outcomesSection",
  "page": "vertaaux-module__2Kcjfa__page",
  "paletteCard": "vertaaux-module__2Kcjfa__paletteCard",
  "paletteCardExcellent": "vertaaux-module__2Kcjfa__paletteCardExcellent",
  "paletteCardFair": "vertaaux-module__2Kcjfa__paletteCardFair",
  "paletteCardFooter": "vertaaux-module__2Kcjfa__paletteCardFooter",
  "paletteCardGood": "vertaaux-module__2Kcjfa__paletteCardGood",
  "paletteCardHeader": "vertaaux-module__2Kcjfa__paletteCardHeader",
  "paletteCardMutedTeal": "vertaaux-module__2Kcjfa__paletteCardMutedTeal",
  "paletteCardNearBlack": "vertaaux-module__2Kcjfa__paletteCardNearBlack",
  "paletteCardPoor": "vertaaux-module__2Kcjfa__paletteCardPoor",
  "paletteCardPureWhite": "vertaaux-module__2Kcjfa__paletteCardPureWhite",
  "paletteCardSurface": "vertaaux-module__2Kcjfa__paletteCardSurface",
  "paletteCardTeal": "vertaaux-module__2Kcjfa__paletteCardTeal",
  "paletteCardWarmInk": "vertaaux-module__2Kcjfa__paletteCardWarmInk",
  "paletteCardWarmWhite": "vertaaux-module__2Kcjfa__paletteCardWarmWhite",
  "paletteCardWhite": "vertaaux-module__2Kcjfa__paletteCardWhite",
  "paletteGrid": "vertaaux-module__2Kcjfa__paletteGrid",
  "paletteGridThree": "vertaaux-module__2Kcjfa__paletteGridThree",
  "paletteHex": "vertaaux-module__2Kcjfa__paletteHex",
  "paletteName": "vertaaux-module__2Kcjfa__paletteName",
  "paletteRole": "vertaaux-module__2Kcjfa__paletteRole",
  "paletteSection": "vertaaux-module__2Kcjfa__paletteSection",
  "paletteSectionTitle": "vertaaux-module__2Kcjfa__paletteSectionTitle",
  "paletteUsage": "vertaaux-module__2Kcjfa__paletteUsage",
  "problemMindmap": "vertaaux-module__2Kcjfa__problemMindmap",
  "processSection": "vertaaux-module__2Kcjfa__processSection",
  "roundedImage": "vertaaux-module__2Kcjfa__roundedImage",
  "storySection": "vertaaux-module__2Kcjfa__storySection",
  "storySectionAlt": "vertaaux-module__2Kcjfa__storySectionAlt",
  "waterfallColumn": "vertaaux-module__2Kcjfa__waterfallColumn",
  "waterfallLabel": "vertaaux-module__2Kcjfa__waterfallLabel",
  "waterfallMonoLine": "vertaaux-module__2Kcjfa__waterfallMonoLine",
  "waterfallSansLine": "vertaaux-module__2Kcjfa__waterfallSansLine",
  "waterfallSize2xl": "vertaaux-module__2Kcjfa__waterfallSize2xl",
  "waterfallSize4xl": "vertaaux-module__2Kcjfa__waterfallSize4xl",
  "waterfallSizeLg": "vertaaux-module__2Kcjfa__waterfallSizeLg",
  "waterfallSizeMd": "vertaaux-module__2Kcjfa__waterfallSizeMd",
  "waterfallSizeSpecimen": "vertaaux-module__2Kcjfa__waterfallSizeSpecimen",
  "waterfallSizeXl": "vertaaux-module__2Kcjfa__waterfallSizeXl",
  "waterfallWrap": "vertaaux-module__2Kcjfa__waterfallWrap",
});
